import { collectOrgIdsForAnyOrgPermission, requireAnySystemPermission, } from '@juvare/contact-management/backend/features/permissions/shared';
export function filterOrganizationIdsUserCanManageMembers(userState, organizationIds) {
    const orgIdsWhereCanManageMembers = collectOrgIdsForAnyOrgPermission(userState, 'manage-members');
    const orgIds = organizationIds !== null && organizationIds !== void 0 ? organizationIds : [];
    return requireAnySystemPermission(userState, 'all-organizations-admin', 'manage-organizations')
        ? orgIds
        : orgIds.filter((id) => orgIdsWhereCanManageMembers.includes(id));
}
